import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function Register() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { register, reset, handleSubmit, errors, getValues } = useForm();

  const {
    register: eRegister,
    handleSubmit: eHandleSubmit,
    errors: eErrors,
    getValues: eGetValues,
    reset: eReset,
  } = useForm();

  const signUpSeeker = (value) => {
    axios.post("/api/seeker/register", value).then((response) => {
      enqueueSnackbar(response.data.message, { variant: response.data.status });
      if (response.data.status == "success") {
        reset();
        $("#sign_up_popup").modal("hide");
        history.push("/login");
      }
    });
  };
  const signUpEmployer = (value) => {
    axios.post("/api/employer/register", value).then((response) => {
      enqueueSnackbar(response.data.message, { variant: response.data.status });
      if (response.data.status == "success") {
        eReset();
        $("#sign_up_popup").modal("hide");
        history.push("/login");
      }
    });
  };

  return (
    <div className="section-full p-t120  p-b60 bg-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <figure className="account-image">
              <img src="/portal/images/login.png" alt="info image" />
            </figure>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="twm-log-reg-form-wrap">
              <h2 className="wt-title text-center">Register</h2>
              {/* <ul>
                    <li>
                      <input
                        type="radio"
                        name="type"
                        className="radio_btn"
                        value="seeker"
                        ref={register()}
                      />
                      Jobseeker
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="type"
                        className="radio_btn"
                        value="employer"
                        ref={register()}
                      />
                      Employer
                    </li>
                  </ul>
                   */}
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    data-bs-toggle="tab"
                    data-bs-target="#sign-candidate-page"
                    type="button"
                  >
                    <i className="fas fa-user-tie"></i>Jobseeker
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    data-bs-toggle="tab"
                    data-bs-target="#sign-Employer-page"
                    type="button"
                  >
                    <i className="fas fa-building"></i>Employer
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="sign-candidate-page"
                >
                  <form onSubmit={handleSubmit(signUpSeeker)}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group mb-3">
                          <input
                            name="username"
                            type="text"
                            id="seeker-username"
                            className={`form-control ${
                              errors.username !== undefined ? "is-invalid" : ""
                            }`}
                            placeholder="Full Name"
                            ref={register({
                              required: "Please enter a full name",
                            })}
                            autoComplete="name"
                          />
                          {errors.username && (
                            <div id="seeker-usernameFeedback" className="text-danger">
                              {errors.username.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group mb-3">
                          <input
                            name="email"
                            type="email"
                            id="seeker-email"
                            className={`form-control ${
                              errors.email !== undefined ? "is-invalid" : ""
                            }`}
                            placeholder="Email"
                            ref={register({
                              required: "Please provide a valid email.",
                              pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address",
                              },
                            })}
                          />
                          {errors.email && (
                            <div id="emailFeedback" className="text-danger">
                              {errors.email.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div
                          className="form-group mb-3 position-relative"
                          id="seeker-passwords-group"
                        >
                          <input
                            name="password"
                            type="password"
                            id="seeker-passwords"
                            className={`form-control ${
                              errors.password !== undefined ? "is-invalid" : ""
                            }`}
                            placeholder="Password"
                            ref={register({
                              required: "Password field is required",
                              pattern: {
                                value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/i,
                                message:
                                  "The password must be at least 8 characters long and contain at least one uppercase letter, digit and a special character",
                              },
                              minLength: {
                                value: 8,
                                message:
                                  "The password must be at least 8 characters long and contain at least one uppercase letter, digit and a special character",
                              },
                            })}
                          />
                          <div
                            className="showPassword"
                            data-relative="#seeker-passwords-group"
                            data-formid="#seeker-passwords"
                            data-show="false"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "5px",
                              cursor: "pointer",
                            }}
                          >
                            <i className="ri-eye-fill"></i>
                          </div>
                          {errors.password && (
                            <div
                              id="seekerPasswordFeedback"
                              className="text-danger"
                            >
                              {errors.password.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div
                          className="form-group position-relative mb-3"
                          id="seeker-passwords_confirmation-group"
                        >
                          <input
                            name="password_confirmation"
                            type="password"
                            id="seeker-passwords_confirmation"
                            className={`form-control ${
                              errors.password_confirmation !== undefined
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Confirm Password"
                            ref={register({
                              required: "Please confirm your password",
                              validate: (value) =>
                                value === getValues("password") ||
                                "Password does not match",
                            })}
                          />
                          <div
                            className="showPassword"
                            data-relative="#seeker-passwords_confirmation-group"
                            data-formid="#seeker-passwords_confirmation"
                            data-show="false"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "5px",
                              cursor: "pointer",
                            }}
                          >
                            <i className="ri-eye-fill"></i>
                          </div>
                          {errors.password_confirmation && (
                            <div
                              id="seeker-password_confirmationFeedback"
                              className="text-danger"
                            >
                              {errors.password_confirmation.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group mb-3">
                          <input
                            name="mobile"
                            type="number"
                            id="seeker-mobile"
                            className={`form-control ${
                              errors.mobile !== undefined ? "is-invalid" : ""
                            }`}
                            placeholder="Mobile"
                            ref={register({
                              required: "Please enter a mobile number",
                              minLength: {
                                value: 10,
                                message: "Mobile number must be 10 digits long",
                              },
                              maxLength: {
                                value: 10,
                                message: "Mobile number must be 10 digits long",
                              },
                            })}
                          />
                          {errors.mobile && (
                            <div
                              id="seeker-mobileFeedback"
                              className="text-danger"
                            >
                              {errors.mobile.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group mb-3">
                          <div className=" form-check">
                            <input
                              type="checkbox"
                              name="terms_condition"
                              className={`form-check-input ${
                                errors.terms_condition !== undefined
                                  ? "is-invalid"
                                  : ""
                              }`}
                              id="seeker-acceptTerms"
                              defaultValue="Y"
                              ref={register({
                                required: "Required",
                              })}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="seeker-acceptTerms"
                            >
                              I agree to the{" "}
                              {/* <a href="javascript:;">Terms and conditions</a> */}
                              <Link to={`/pages/terms-and-conditions`} target="_blank">Terms and conditions</Link> and 
                              <Link to={`/pages/privacy-policy`} target="_blank"> Privacy Policy</Link>
                            </label>
                            <p>
                              Already registered? 
                               <Link to="/login"> Log in here </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <button type="submit" className="site-button">
                          Sign Up
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="tab-pane fade" id="sign-Employer-page">
                  <form onSubmit={eHandleSubmit(signUpEmployer)}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group mb-3">
                          <input
                            name="username"
                            type="text"
                            id="username"
                            className={`form-control ${
                              eErrors.username !== undefined ? "is-invalid" : ""
                            }`}
                            placeholder="Full Name"
                            ref={eRegister({
                              required: "Please enter a full name",
                            })}
                            autoComplete="name"
                          />
                          {eErrors.username && (
                            <div id="usernameFeedback" className="text-danger">
                              {eErrors.username.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group mb-3">
                          <input
                            name="email"
                            type="email"
                            id="email"
                            className={`form-control ${
                              eErrors.email !== undefined ? "is-invalid" : ""
                            }`}
                            placeholder="Email"
                            ref={eRegister({
                              required: "Please provide a valid email.",
                              pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address",
                              },
                            })}
                          />
                          {eErrors.email && (
                            <div id="emailFeedback" className="text-danger">
                              {eErrors.email.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div
                          className="form-group mb-3 position-relative"
                          id="passwords-group"
                        >
                          <input
                            name="password"
                            type="password"
                            id="passwords"
                            className={`form-control ${
                              eErrors.password !== undefined ? "is-invalid" : ""
                            }`}
                            placeholder="Password"
                            ref={eRegister({
                              required: "Password field is required",
                              minLength: {
                                value: 8,
                                message:
                                  "Password must be minimun of 8 characters",
                              },
                            })}
                          />
                          <div
                            className="showPassword"
                            data-relative="#passwords-group"
                            data-formid="#passwords"
                            data-show="false"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "5px",
                              cursor: "pointer",
                            }}
                          >
                            <i className="ri-eye-fill"></i>
                          </div>
                          {eErrors.password && (
                            <div id="passwordFeedback" className="text-danger">
                              {eErrors.password.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div
                          className="form-group mb-3 position-relative"
                          id="passwords_confirmation-group"
                        >
                          <input
                            name="password_confirmation"
                            type="password"
                            id="passwords_confirmation"
                            className={`form-control ${
                              eErrors.password_confirmation !== undefined
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Confirm Password"
                            ref={eRegister({
                              required: "Please confirm your password",
                              validate: (value) =>
                                value === eGetValues("password") ||
                                "Password does not match",
                            })}
                          />
                          <div
                            className="showPassword"
                            data-relative="#passwords_confirmation-group"
                            data-formid="#passwords_confirmation"
                            data-show="false"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "5px",
                              cursor: "pointer",
                            }}
                          >
                            <i className="ri-eye-fill"></i>
                          </div>
                          {eErrors.password_confirmation && (
                            <div
                              id="password_confirmationFeedback"
                              className="text-danger"
                            >
                              {eErrors.password_confirmation.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group mb-3">
                          <input
                            name="mobile"
                            type="number"
                            id="mobile"
                            className={`form-control ${
                              eErrors.mobile !== undefined ? "is-invalid" : ""
                            }`}
                            placeholder="Mobile"
                            ref={eRegister({
                              required: "Please enter a mobile number",
                              minLength: {
                                value: 10,
                                message: "Mobile number must be 10 digits long",
                              },
                              maxLength: {
                                value: 10,
                                message: "Mobile number must be 10 digits long",
                              },
                            })}
                          />
                          {eErrors.mobile && (
                            <div id="mobileFeedback" className="text-danger">
                              {eErrors.mobile.message}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group mb-3">
                          <div className=" form-check">
                            <input
                              type="checkbox"
                              name="terms_condition"
                              className={`form-check-input ${
                                eErrors.terms_condition !== undefined
                                  ? "is-invalid"
                                  : ""
                              }`}
                              id="acceptTerms"
                              defaultValue="Y"
                              ref={eRegister({
                                required: "Required",
                              })}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="acceptTerms"
                            >
                              I agree to the{" "}
                              {/* <a href="javascript:;">Terms and conditions</a> */}
                              <Link to={`/pages/terms-and-conditions`} target="_blank">Terms and conditions</Link> and 
                              <Link to={`/pages/privacy-policy`} target="_blank"> Privacy Policy</Link>
                            </label>
                            <p>
                              Already registered?
                              {/* <button
                                type="button"
                                className="twm-backto-login"
                                data-bs-target="#sign_up_popup2"
                                data-bs-toggle="modal"
                                data-bs-dismiss="modal"
                              >
                                Log in here
                              </button> */}

                              <Link to="/login"> Log in here </Link>

                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <button type="submit" className="site-button">
                          Sign Up
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="clearfix"></div> */}
        </div>
      </div>
    </div>
  );
}
